module.exports = __webpack_public_path__ + "img/project11_3.0c260ed7.png";